import { key_exists } from './key_exists'

const load_raw_polygon_data = (device_data: any): any => {
    let polygon = null
    // const path_frame_base =
    //   "config.base.vehicle_detection.scanner.trajectory_classification.extrapolation.frame.frame_info";
    const path_frame_diff =
        'config.diff.vehicle_detection.scanner.trajectory_classification.extrapolation.frame.frame_info'

    if (key_exists(device_data, path_frame_diff))
        polygon =
            device_data.config.diff.vehicle_detection.scanner.trajectory_classification.extrapolation.frame.frame_info
    if (polygon !== null) {
        return polygon
    }

    // if (key_exists(device_data, path_frame_base))
    //   polygon =
    //     device_data.config.base.vehicle_detection.scanner
    //       .trajectory_classification.extrapolation.frame.frame_info;
    // if (polygon !== null) {
    //   console.log("loaded polygon from base config: ", polygon);
    //   // CHANGE THIS BACK TO POLYGON ONCE THE BASE CONFIG HAS CHANGED to [0...1]
    //   return null
    //   //return polygon;
    // }

    return polygon
}

export const input_tranformation_polygon = (device_data: any, image_widht: number, image_height: number) => {
    const polygon_raw = load_raw_polygon_data(device_data)
    if (polygon_raw === null) {
        return null
    }
    const lines = polygon_raw.map((element: any, index: number) => {
        return {
            name: `line_${index}`,
            ref: element.ref,
            points: [
                [element.point_a[0] * image_widht, element.point_a[1] * image_height],
                [element.point_b[0] * image_widht, element.point_b[1] * image_height]
            ]
        }
    })
    const points = polygon_raw.map((element: any) => {
        return [element.point_a[0] * image_widht, element.point_a[1] * image_height]
    })
    const polygon = {
        points: points,
        flattenedPoints: points.flat(),
        lines: lines
    }
    return polygon
}
